import { Flex, Spinner } from "@chakra-ui/react";
import { useEffect } from "react";
import { useWalletBalance } from "thirdweb/react";

export function ReadBalanceNative({ total, setRequiredAmount, setRawBalance, setBalanceAmount, walletAddress, chain, client }: { total: number, setRequiredAmount: (value: number) => void, setRawBalance: (value: number) => void, setBalanceAmount: (value: number) => void, walletAddress: string, chain: any, client: any }) {
    const { data: balance, isLoading, isError } = useWalletBalance({
        chain,
        address: walletAddress,
        client,
    });  

    useEffect(() => {
        if(!isLoading) {
            let requiredAmountTotal = BigInt(Math.floor(total * 10 ** balance?.decimals));
            setRequiredAmount(requiredAmountTotal)
            setBalanceAmount(Number(balance?.displayValue))
            setRawBalance(balance?.value)
        }
    }, [isLoading])

    return (
        <Flex w='full' fontSize={'18px'}>
            <Flex>Balance:</Flex>
            <Flex ml='auto' fontWeight={'700'}>
                {(isLoading) ? <Spinner w='22px' h='22px' color='white' /> : <>{balance?.displayValue} {balance?.symbol}</>}
            </Flex>
        </Flex>
    );
}